import { render, staticRenderFns } from "./OperationTypeDetail.vue?vue&type=template&id=21fccee5"
import script from "./OperationTypeDetail.vue?vue&type=script&lang=js"
export * from "./OperationTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./OperationTypeDetail.vue?vue&type=style&index=0&id=21fccee5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports